function initializeVideoFileControls(videoPlayer, isInsideCarousel) {
  var videoElement = videoPlayer.querySelector('video');
  var durationEl = videoPlayer.querySelector('.custom-controls__duration');
  var seekEl = videoPlayer.querySelector('input');
  var progressEl = videoPlayer.querySelector('progress');

  if (!isInsideCarousel && videoElement.autoplay) {
    videoElement.oncanplaythrough = function () {
      videoElement.play();
    }
  }

  videoElement.addEventListener('pause', () => {
    videoPlayer.classList.remove('playing');
  });
  videoElement.addEventListener('play', () => {
    videoPlayer.classList.add('has-started');
    videoPlayer.classList.add('playing');
  });
  videoElement.addEventListener('requestFullscreen', () => {
    videoPlayer.classList.add('fullscreen');
  });
  videoElement.addEventListener('exitFullscreen', () => {
    videoPlayer.classList.remove('fullscreen');
  });
  videoElement.addEventListener('volumechange', () => {
    videoElement.volume === 0
      ? videoPlayer.classList.add('muted')
      : videoPlayer.classList.remove('muted');
  });
  videoElement.addEventListener('ended', () => {
    videoPlayer.classList.remove('playing');
  });
  videoElement.addEventListener('loadeddata', function () {
    const videoDuration = Math.round(videoElement.duration);
    seekEl.setAttribute('max', videoDuration);
    progressEl.setAttribute('max', videoDuration);
    const time = formatTime(videoDuration);
    videoPlayer.querySelector('.custom-controls').classList.add('initiated');
    durationEl.innerText = (time.minutes !== '00' ? time.minutes : '0') + ':';
    durationEl.innerText = durationEl.innerText + time.seconds;
    durationEl.setAttribute('datetime', `${time.minutes}m ${time.seconds}s`)
  });
  videoPlayer.addEventListener('click', function (e) {
    if (videoPlayer.querySelector('.custom-controls').contains(e.target)) {
      return;
    }
    if (videoPlayer.classList.contains('playing')) {
      videoElement.pause();
    }
    else {
      videoElement.play();
    }
  });
  videoElement.addEventListener('timeupdate', onTimeUpdate);
  ['mousedown', 'touchstart'].forEach(function (ev) {
    seekEl.addEventListener(ev, () => {
      videoElement.removeEventListener('timeupdate', onTimeUpdate);
    });
  });
  ['mouseup', 'touchend'].forEach(function (ev) {
    seekEl.addEventListener(ev, (e) => {
      videoElement.addEventListener('timeupdate', onTimeUpdate);
      videoElement.currentTime = e.target.value;
    });
  });
  videoPlayer.querySelector('.btn-pause').addEventListener('click', function () {
    videoElement.pause();
  });
  videoPlayer.querySelector('.btn-play').addEventListener('click', function () {
    videoElement.play();
  });
  videoPlayer.querySelector('.btn-fullscreen').addEventListener('click', function () {
    videoElement.requestFullscreen();
  });
  videoPlayer.querySelector('.btn-exitfullscreen').addEventListener('click', function () {
    videoElement.exitFullscreen();
  });
  if (!videoPlayer.classList.contains('hero-video-block')) {
    videoPlayer.querySelector('.btn-volumeon').addEventListener('click', function () {
      if (videoElement.autoplay) {
        videoElement.autoplay = false;
        videoElement.muted = false;
      }
      else {
        videoElement.volume = 1;
      }
    });
    videoPlayer.querySelector('.btn-volumeoff').addEventListener('click', function () {
      videoElement.volume = 0;
    });
  }

  function onTimeUpdate() {
    seekEl.value = Math.floor(videoElement.currentTime);
    durationEl.innerText = (formatTime(videoElement.currentTime).minutes !== '00' ? formatTime(videoElement.currentTime).minutes : '0') + ':';
    durationEl.innerText = durationEl.innerText + formatTime(videoElement.currentTime).seconds;
    progressEl.setAttribute('value', videoElement.currentTime);
  }

  function formatTime(timeInSeconds) {
    const result = new Date(timeInSeconds * 1000).toISOString().substr(11, 8);

    return {
      minutes: result.substr(3, 2),
      seconds: result.substr(6, 2),
    };
  };
}

window.initializeVideoFileControls = initializeVideoFileControls;